/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-multi-spaces */
import {GenericObject} from '@ion/core/src/types/entities';

// ESRI basemap types.
export enum BasemapTypes {
  grayVector              = 'gray-vector',
  hybrid                  = 'hybrid',
  satellite               = 'satellite',
  osm                     = 'osm',
  streetsNavigationVector = 'streets-navigation-vector',
  topoVector              = 'topo-vector'
};

// ESRI basemap titles
export const basemapTitle = {
  [BasemapTypes.grayVector]              : 'Light Gray Canvas',
  [BasemapTypes.hybrid]                  : 'Imagery with Labels',
  [BasemapTypes.satellite]               : 'Imagery',
  [BasemapTypes.osm]                     : 'OpenStreetMap',
  [BasemapTypes.streetsNavigationVector] : 'World Navigation Map',
  [BasemapTypes.topoVector]              : 'Topographic'
};

// Map tool identifiers.
export enum MapTools {
  zoomInOut         = 'zoom-in-out',
  scaleBar          = 'scale-bar',
  basemapGallery    = 'basemap-gallery',
  goToHome          = 'go-to-home',
  refreshMap        = 'refresh-map',
  location          = 'location',
  searchMap         = 'search-map',
  mapSearchView     = 'map-search-view',
  createGeoFence    = 'create-geofence',
  mapCreateGeofence = 'map-create-geofences',
  layerChooser      = 'layer-chooser',
  mapLayerChooser   = 'map-layer-chooser',
  timeSlider        = 'timeSlider',
  moreMenu          = 'more-menu',
  fullScreen        = 'full-screen',
  savedMap          = 'saved-map',
  savedMapView      = 'saved-map-view'
};

// ESRI map tool positions.
export enum MapToolPositions {
  bottomLeft  = 'bottom-left',
  bottomRight = 'bottom-right',
  topRight    = 'top-right',
  topLeft     = 'top-left'
};

// Map color modes.
export enum MapColorModes {
  light = 'light',
  dark  = 'dark'
};

// Properties for tools placed on the Basemap layer.
export type BasemapLayerTool = {
  id: MapTools;
  position: MapToolPositions;
  props?: GenericObject;
};
